import { ref, getCurrentInstance, onBeforeUnmount } from '@vue/composition-api';
import { createApolloClient } from '@/components/commons/apollo.js';
import useEventHook from './useEventHook.js';

const vueInstance = getCurrentInstance();

/**
 * Execute a query operation to fetch data from the GraphQL API endpoint.
 * @param {string} query GraphQL query to be executed
 * @param {object} variables The values of the variables used in the query
 * @param {object} options Additional query options, like caching and fetching policy
 */
export default function useQuery(query, variables = {}, overrideOptions = {}) {
  const loading = ref(true);
  const error = ref(null);
  const result = ref(null);

  const resultEvent = useEventHook();
  const errorEvent = useEventHook();

  const currentOptions = {};

  const apolloClient = createApolloClient(process.env.STOREFRONT_SERVER);

  async function start() {
    try {
      loading.value = true;
      const queryResult = await apolloClient.query({
        query,
        variables,
        ...currentOptions,
        ...overrideOptions,
      });

      loading.value = queryResult?.loading;
      result.value = queryResult?.data;
      resultEvent.trigger(queryResult?.data);
    } catch (e) {
      error.value = e;
      loading.value = false;
      errorEvent.trigger(e);
      throw e;
    }
  }

  vueInstance &&
    onBeforeUnmount(() => {
      loading.value = false;
    });

  start();

  return {
    loading,
    result,
    error,
    onResult: resultEvent.on,
    onError: errorEvent.on,
  };
}
